import React, { useEffect, useState } from "react";
import debounce from "lodash/debounce";
import { getNumberWithUnit } from "@hedgefund/shared";
import { useDispatch, useSelector } from "react-redux";
import { investFund } from "./actions";
import { useQuery } from "../../utils/CustomHook";
import Funds from "../shared/Funds";

const data3 = [{ option: "AUM" }];

const MyFunds = () => {
  const query = useQuery();
  const searchOptions = query.get("keyword") || "";
  const dropDownValue = query.get("dropDownValue") || null;
  const [page, setPage] = useState(1);
  const [firstCall, setFirstCall] = useState(true);
  const [strategyFilter, setStrategyFilter] = useState(dropDownValue);
  const [searchValue, setSearchValue] = useState(searchOptions);
  const dispatch = useDispatch();
  const fundState = useSelector((state) => state.hedgefund);
  const dashboardState = useSelector((state) => state.dashboard);
  const [filterStrategyShow, setFilterStrategyShow] = useState(false);

  useEffect(() => {
    // dispatch(getStrategies());
    setFirstCall(false);
    loadData();
  }, []);

  useEffect(() => {
    if (!firstCall) {
      loadData();
    }
  }, [strategyFilter]);

  useEffect(() => {
    if (!firstCall) {
      loadData();
    }
  }, [page]);

  useEffect(() => {
    setPage(1);
    dispatch(
      investFund({
        page: 1,
        limit: 20,
        strategy: strategyFilter,
        keyword: searchValue,
      })
    );
  }, [searchValue]);

  const handleSearch = debounce((text) => {
    setSearchValue(text);
  }, 1000);

  const loadData = () => {
    dispatch(
      investFund({
        page: page,
        limit: 20,
        strategy: strategyFilter,
        keyword: searchValue,
      })
    );
  };

  const onClickCrossHandler = () => {
    setStrategyFilter([]);
    setFilterStrategyShow(false);
  };
  const onChangeFilterData = (e) => {
    setStrategyFilter(e.target.value);
    setFilterStrategyShow(true);
  };

  return (
    <Funds
      title="My Funds"
      searchValue={searchValue}
      handleSearch={handleSearch}
      filterStrategyShow={filterStrategyShow}
      dashboardState={dashboardState}
      strategyFilter={strategyFilter}
      onClickCrossHandler={onClickCrossHandler}
      onChangeFilterData={onChangeFilterData}
      data3={data3}
      fundState={fundState}
      getNumberWithUnit={getNumberWithUnit}
    />
  );
};

export default MyFunds;
